import ky from 'ky-universal';

export const prefixUrl = process.env.VUE_APP_API_URL || 'http://localhost:8080/api';
const publicPath = process.env.VUE_APP_PUBLIC_PATH + '/' || '/';

export const fetcher = ky.create({
  retry: 1,
  prefixUrl,
  hooks: {
    afterResponse: [
      async (_request, _options, response) => {
        // ステータス503は混雑中ページに飛ばす
        if (response.status === 503) {
          try {
            const json = await response.json();
            const title = json?.title || '';
            const message = json?.message || '';
            window.location.href = `${publicPath}error/busy?title=${title}&message=${message}`;
          } catch (e) {
            window.location.href = `${publicPath}error/busy`;
          }
        }
        // 500はシステムエラーページに飛ばす
        if (response.status === 500) {
          window.location.href = `${publicPath}error`;
        }
      },
    ],
  },
});
